export default __webpack_public_path__ + "static/media/logo.f13d3fc6.png";